<div class="cooking-container">
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/cookingbook/users.svg" alt="" />

      <p>افراد خانه</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-body">
    <ng-container>
      <div class="member">
        <img class="profile" [src]="getProfile(data.owner)" alt="" />
        <div>
          <p>{{ data.owner.name }}</p>
          <span>مدیر خانه</span>
        </div>
      </div>
    </ng-container>
    <p class="invite-title">
      شما به خانه {{ data.owner.name }} دعوت شدید. با قبول کردن این درخواست،
      لیست خرید و آشپزخانه {{ data.owner.name }} با شما به اشتراک گذاشته می‌شود
      و لیست فعلی شما پاک می‌شود.
    </p>
    <div class="buttons">
      <div class="accept" (click)="accept()">عضویت در خانه</div>
      <div class="reject" (click)="goBack()">لغو</div>
    </div>
  </div>
</div>
